import { apiClient } from './client';

export interface BlucherryRemediationParams {
  orderNames?: string[];
  remediateStart?: string;
  remediateEnd?: string;
  backfillOnly?: boolean;
  dryRun?: boolean;
}

export interface BlucherryRemediationResponse {
  message: string;
  affected_count?: number;
}

export function triggerRemediation (shopId: string | number, params: BlucherryRemediationParams = {}) {
  return apiClient.post<BlucherryRemediationResponse>(`/${shopId}/bluecherry/remediate`, params);
}
